import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";

function CourtesyLiveScreen() {
  const [isAnimation, setIsAnimation] = useState(false);
  const [TotalCompleted, setTotalCompleted] = useState(0);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    // getScreenListData();
    getScreenData();
  }, []);

  useEffect(() => {
    const element = document.getElementById("tbllocations");
    element?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }, [screenData]);

  function getScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetCourtesyLiveScreenData",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          setTotalCompleted(response.data.Data[1][0].TotalCompleted);
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function PTFilesGetDataSetToCopy() {
    setIsAnimation(true);
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.APIURL + "api/PTSupport/PTFilesGetDataSetToCopy",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "PTSupportTypeName")) {
        (
          document.getElementById(
            "imgSort" + "PTSupportTypeName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "FirstName")) {
        (
          document.getElementById("imgSort" + "FirstName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "LastName")) {
        (
          document.getElementById("imgSort" + "LastName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      <>
        <div className="flex-d justify-btw mb-10">
          <span></span>
          <div className="flex-daj flex-gap10">
            <a
              className="link-btn btn-link-m"
              onClick={() => ClearAllFilters()}
            >
              Clear All Filters
            </a>
            <a
              className="link-btn btn-link-m no-display"
              onClick={() => PTFilesGetDataSetToCopy()}
            >
              Upload Files to S3
            </a>
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tbllocations",
                  "Courtesy - Live screen",
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        </div>
        <div className="flow-auto">
          <table className="reuse-table" id="tbllocations">
            <thead>
              <tr>
                <th className="reuse-tdsm">
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Status
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "StatusName")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("StatusName")}
                        title={"Sort By Status"}
                      >
                        <span id={"imgSort" + "StatusName"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Client Name
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "ClientName")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("ClientName")}
                        title={"Sort By Client Name"}
                      >
                        <span id={"imgSort" + "ClientName"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap5">
                      Move Manager
                      <a
                        onClick={(e) =>
                          ShowColumnFilterList(e, "MoveManagerNames")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("MoveManagerNames")}
                        title={"Sort By Move Manager Names"}
                      >
                        <span id={"imgSort" + "MoveManagerNames"}></span>
                      </a>
                    </div>
                  </div>
                </th>
                <th>Time</th>
                <th>Date</th>
                <th>Call Before </th>
                <th>Call Before Notes</th>
                <th>Call After</th>
                <th>Call After Notes</th>
                <th className="td-xxxs">Link</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <>
                        <tr>
                          <td>
                            {index < TotalCompleted && (
                              <>
                                {item.StatusName == "P" && (
                                  <a
                                    title="Provisional"
                                    style={{ background: "#ff7f27" }}
                                    className="booked-01"
                                  >
                                    P
                                  </a>
                                )}

                                {item.StatusName == "C" && (
                                  <a
                                    title="Confirmed"
                                    className="booked-01"
                                    style={{ background: "#00a2e8" }}
                                  >
                                    C
                                  </a>
                                )}

                                {item.StatusName == "A" && (
                                  <a
                                    title="Accepted"
                                    className="booked-01"
                                    style={{ background: "#22b14c" }}
                                  >
                                    A
                                  </a>
                                )}

                                {item.StatusName == "B" && (
                                  <a
                                    title="Booked"
                                    className="booked-01"
                                    style={{ background: "#7f7f7f" }}
                                  >
                                    B
                                  </a>
                                )}

                                {item.StatusName == "R" && (
                                  <a
                                    title="Reserved"
                                    className="booked-01"
                                    style={{ background: "#FFF77D" }}
                                  >
                                    R
                                  </a>
                                )}
                              </>
                            )}
                            {item.StatusName == "C" &&
                              index >= TotalCompleted && (
                                <a
                                  title="Completed"
                                  className="booked-01"
                                  style={{ background: "#a349a4" }}
                                >
                                  C
                                </a>
                              )}
                          </td>
                          <td>{item.ClientName}</td>
                          <td>{item.MoveManagerNames}</td>
                          <td>{item.RequestedTime}</td>
                          <td>{formateDate(item.RequestedDate)}</td>
                          <td>{item.CourtesyCallBefore == true ? "Yes" : ""}</td>
                          <td>{item.CourtesyCallBeforeNotes}</td>
                          <td>{item.CourtesyCallAfter == true ? "Yes" : ""}</td>
                          <td>{item.CourtesyCallAfterNotes}</td>
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                href={"/quote_detail/" + item.MNVJobID}
                                target="_blank"
                              >
                                <img
                                  src="images/link.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Preview"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                        {index == TotalCompleted - 1 && (
                          <tr>
                            <td colSpan={10}></td>
                          </tr>
                        )}
                      </>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </>
    </div>
  );
}

export default CourtesyLiveScreen;
